export const getRedemptionErrorMessage = (data) => {
    if (!data) return "An unexpected error occurred.";

    const code = String(data.ErrorCode ?? "");
    console.log("Redemption error code:", data);

    if (code === "0" || code === "") return null;

    if (code === "9" || code === "BALANCE_ERROR" || code === "INSUFFICIENT_FUNDS") {
        return "Card has zero balance.";
    }

    if (code === "40" || code === "CERT_NOT_ACTIVE") {
        return "Card not activated, customer to contact issuer.";
    }

    if (code === "27" || code === "CERT_ON_HOLD") {
        return "Card on hold, customer to contact issuer.";
    }

    if (code === "6" || code === "CERT_EXPIRED") {
        return "Card expired.";
    }

    if (code === "28" || code === "CERT_CANCELLED") {
        return "Card cancelled, customer to contact issuer.";
    }

    if (code === "19" || code === "OPERATION_NOT_PERMITTED") {
        return "Card type not valid for your venue.";
    }

    if (code === "41") return "Incorrect pin number.";

    return data.ErrorMessage || "An unexpected error occurred.";
};
